import { INIT_UI , SHOW_SELECTOR, CLOSE_SELECTOR} from './types';
export const initUi = () => {
    return {type: INIT_UI}
}

export const showSelection  = (type,toggle) => dispatch => {
    if( !toggle){
        dispatch( { type: SHOW_SELECTOR, payload: type })
    }
    else {
        dispatch( { type: CLOSE_SELECTOR, payload: type })
    }
}
